import { type PropsWithChildren, createContext, useContext, useState } from 'react';

type PageContextType = {
  title: string | null;
  setTitle: (title: string | null) => void;
  exampleAIQuestions: string[];
  setExampleAIQuestions: (questions: string[]) => void;
};

const PageContext = createContext<PageContextType | undefined>(undefined);

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
};

export const PageProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState<string | null>(null);
  const [exampleAIQuestions, setExampleAIQuestions] = useState<string[]>([]);

  return (
    <PageContext.Provider value={{ title, setTitle, exampleAIQuestions, setExampleAIQuestions }}>
      {children}
    </PageContext.Provider>
  );
};
